import React from 'react';
import { Picture } from '@ycos/picture';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Header from '../Header/Header';
import HeaderNav from '../HeaderNav/HeaderNav';

const bem = new BEMHelper('ContentHeader');

export const generateGreeting = (messages, user) => {
    const currentHour = new Date().getHours();

    const userDetails = {
        userFirstName: user?.firstName,
        userLastName: user?.lastName,
        personTitle: user?.personTitle,
    };

    if (currentHour < 12) {
        return messages?.eipGreeting?.morning(userDetails);
    }

    if (currentHour < 18) {
        return messages?.eipGreeting?.afternoon(userDetails);
    }

    return messages?.eipGreeting?.evening(userDetails);
};

const ContentHeader = (props) => {
    const {
        banners,
        copy,
        fullbleed,
        hasCarouselContent,
        headerActions,
        imageQuality,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        internal_urls,
        loading,
        locale,
        messages,
        picturesAndMedia,
        preTitle,
        saleTitle,
        subCategoryLinks,
        subTitle,
        tags,
        title,
        urlConfig,
        user,
    } = props;

    const banner = picturesAndMedia.length > 0 ? 'banner' : '';
    const eipGreeting = tags && tags.includes('eipbanner') ? 'eipGreeting' : '';
    const greetingTitle = eipGreeting && user?.isEip && generateGreeting(messages, user);
    const fixImageHeight = tags && !tags.includes('medium') && tags.includes('textbelow') && 'fixImageHeight';
    const includeMobile = tags && tags.includes('medium') && tags.includes('mobile') && 'includeMobile';
    const loadingModifier = loading && 'skeleton';
    const hasSubCategoryLinksModifier = subCategoryLinks ? 'subCategoryLinks' : '';
    const hasCarouselContentModifier = hasCarouselContent ? 'carouselContent' : '';
    const fullBleedModifier = fullbleed && !banner ? 'fullBleed' : '';
    const fullBleedOnBanner = fullbleed && banner ? 'fullBleedBanner' : '';
    const sharedTags = [loadingModifier, hasSubCategoryLinksModifier, hasCarouselContentModifier, banner, eipGreeting, fullBleedModifier, fullBleedOnBanner];
    const containerModifier = tags ? [...tags, fixImageHeight, includeMobile, ...sharedTags] : sharedTags;
    const copyContent = tags && tags.includes('skinny') ? '' : copy; // hide copy if it's skinny

    return (
        <>
            <div className={bem(null, containerModifier)}>
                {banners && (
                    <div className={bem('headerImage', containerModifier)}>
                        <div className={bem('imageWrapper')}>
                            <Picture
                                images={picturesAndMedia}
                                lazy={false}
                                widths={[3000]}
                                imagesphere={{
                                    quality: imageQuality,
                                }}
                            />
                        </div>
                    </div>
                )}
                <Header
                    copy={copyContent}
                    hasImage={picturesAndMedia.length > 0}
                    internal_urls={internal_urls}
                    loading={loading}
                    locale={locale}
                    messages={messages}
                    preTitle={eipGreeting ? greetingTitle : preTitle}
                    saleTitle={saleTitle}
                    subTitle={subTitle}
                    title={title}
                    urlConfig={urlConfig}
                    className={{
                        containerClass: bem('container', containerModifier),
                        contentClass: `${banner} ${bem('content', containerModifier)}`,
                        contentModifier: containerModifier,
                    }}
                >
                    {headerActions}
                </Header>
            </div>
            {subCategoryLinks && (
                <div className={bem('subCategoryLinks', { fullbleed })}>
                    <HeaderNav internal_urls={internal_urls} loading={loading} locale={locale} subCategoryLinks={subCategoryLinks} urlConfig={urlConfig} />
                </div>
            )}
        </>
    );
};

ContentHeader.defaultProps = {
    picturesAndMedia: [],
};

ContentHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    copy: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    tags: PropTypes.string,
    pageType: PropTypes.string,
    banners: PropTypes.object,
    locale: PropTypes.string,
    preTitle: PropTypes.object,
    urlConfig: PropTypes.object,
    internal_urls: PropTypes.object,
    messages: PropTypes.object,
    saleTitle: PropTypes.bool,
    subCategoryLinks: PropTypes.array,
    hasCarouselContent: PropTypes.bool,
    withSkeleton: PropTypes.bool,
    ssr: PropTypes.bool,
    fullbleed: PropTypes.bool,
    headerActions: PropTypes.node,
    picturesAndMedia: PropTypes.array,
    user: PropTypes.object,
};

export default ContentHeader;
